export function hasNoUsableLinkedProject(detail: string): boolean {
  return /no linked project found|no project specified.*railway link|project is deleted.*railway link/i.test(
    detail
  )
}
